import React, {useEffect, useMemo, useState} from 'react';
import Search from "../../../components/search/Search";
import SearchSection from "../../../components/search/SearchSection";
import Selector from "../../../components/selector/Selector";
import {searchListener, searchWithChildren} from "../../../components/commonmethod/simmsDrawerMethod";
import {CodeSpecNum, ContentCategory} from "../../../constant/CodeSpecNum";
import {RENTAL_REQUEST_USER_HEADER} from "../../../components/table/header/Headers";
import {SearchProgressComboBox} from "../../../components/select/SearchProgressComboBox";
import {getIndividualSetting, resetIndividualSetting, setIndividualSetting} from "../../../api/user/UserAccountService";
import {extractObject, initHeaderOrders, nonObject, simmsColumnsToJsGridHeaders} from "../../../components/commonmethod/CommonMethod";
import SimmsInputSearch from "../../../components/input/SimmsInputSearch";
import SimmsDrawerSearch from "../../../components/drawer/simms/SimmsDrawerSearch";
import SimmsJsGrid from "../../../components/js-grid/SimmsJsGrid";
import JsGridExcelGridOpenButton from "../../../components/js-grid/JsGridExcelGridOpenButton";
import {useNavigate} from "react-router-dom";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../components/pageTabs/pageTabsStorage";

const RentalRequestUserListType = ({data, date, pageInfo, dataHook}) => {
    const navigate = useNavigate();
    const {handleSearch, handlePageSizeChange, saveConditions, refresh, handleGridPageChange} = dataHook;

    const [header, setHeader] = useState({order: RENTAL_REQUEST_USER_HEADER(refresh), exclude: []});
    const [exclude, setExclude] = useState([]);
    const [, setPin] = useState();

    const searchDate = {startDate: saveConditions.startDate ?? date.startDate, endDate: saveConditions.endDate ?? date.endDate}

    useEffect(() => {
        getIndividualSetting().then(r => {
            initHeaderOrders(r, RENTAL_REQUEST_USER_HEADER(refresh), setHeader, exclude, setExclude, setPin, 'rental_user_v2');
        })
    }, [])

    const handleRowClick = (row) => {
        const id = row?.id;
        if (id == null) return;
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(row, "대여신청 상세"),
            url: `/lifecycle/rentalRequestUser/${id}`,
        });
    };

    const rentalRequestJsGridHeader = useMemo(() => simmsColumnsToJsGridHeaders(header), [header]);
    const excelGridSearch = useMemo(() => extractObject(saveConditions), [saveConditions]);

    return (
        <div className="container-height">
            <Search refresh={refresh} entity={'rental_user'} searchConditions={saveConditions} handleSearch={handleSearch} handlePageSizeChange={handlePageSizeChange} pageInfo={pageInfo}
                    searchBar={{placeHolder: '자산명, 자산코드'}} size detail date={searchDate}>
                <SearchSection>
                    <Selector showLabel
                                 onChange={(value) => searchWithChildren(handleSearch, 'rentalAssetCode', extractObject(saveConditions), value)}
                                 data={saveConditions.rentalAssetCode}
                                 parentKey={CodeSpecNum.RentalAssetCode} recursive
                                 entity={"code"} title={"대여자산그룹"}/>
                    <SearchProgressComboBox title={"신청상태"} target={"rentalType"} tableName={ContentCategory.RENTAL_ASSET} value={saveConditions}
                                            onChange={(v) => nonObject(saveConditions, v, handleSearch, "rentalType")}
                    />
                    <Selector showLabel
                                 onChange={(value) => searchListener(handleSearch, 'rentApprover', extractObject(saveConditions), value)}
                                 data={saveConditions.rentApprover}
                                 uniqueKey={"rentApprover"}
                                 title={"대여 승인자"} entity="userAccount">
                        <SimmsInputSearch type={'TEXT'} placeHolder={"사용자명"} />
                        <SimmsDrawerSearch showLabel title={'부서'} entity={'department'} target={'department'} recursive />
                        <SimmsDrawerSearch showLabel title={'업체'} entity={'company'} target={'company'} />
                    </Selector>
                </SearchSection>
            </Search>

            <div className="container-height-body">
                <SimmsJsGrid
                    loading={dataHook.loading}
                    resizable={true}
                    data={data}
                    theme={'linear'}
                    style={{minHeight: 0, height: '100%'}}
                    header={rentalRequestJsGridHeader}
                    onHeaderSave={(v) => setIndividualSetting({headers: {'rental_user_v2': v}})}
                    onHeaderReset={() => resetIndividualSetting('headers', 'rental_user_v2')}
                    onRowClick={handleRowClick}
                    onPageChange={handleGridPageChange}
                    toolbarEnd={() => (
                        <div className="flex items-center gap-2">
                            <JsGridExcelGridOpenButton entityName="RentalRequestUser" search={excelGridSearch} />
                            <button
                                type="button"
                                className="text-[13px] px-3 py-0.5 border text-white bg-themeDark rounded-4"
                                onClick={() => navigate('/lifecycle/rentalRequestUser/create')}
                            >
                                등록
                            </button>
                        </div>
                    )}
                />
            </div>
        </div>
    );
};

export default RentalRequestUserListType;
